import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

const ReadOnlyInput = ({ screen, modal, id, name, value, lookup, consignment, toolTip, rowProps }) => {
  const { data, currentConsignment } = useContext(GBENSContext);

  const _value = useMemo(() => {
    return value
      ? value
      : consignment
        ? currentConsignment?.[modal]?.[id]
        : modal
          ? data?.[screen]?.[modal]?.[id]
          : data?.[screen]?.[id];
  }, [value, modal, id, consignment]);

  const valueToUse = useMemo(() => {
    if (lookup) {
      return lookup.find((l) => l.key === _value).value;
    } else return _value;
  }, [lookup, _value]);

  return (
    <Row
      name={name}
      warning={false}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <TextField
          value={valueToUse}
          id={id}
          variant="standard"
          fullWidth
          slotProps={{ input: { readOnly: true } }}
          sx={{
            backgroundColor: 'white',
            '& .MuiInput-underline:before': {
              borderBottom: 'none !important',
            },
            '& .MuiInput-underline:hover:before': {
              borderBottom: 'none !important',
            },
            '& .MuiInput-underline:after': {
              borderBottom: 'none !important',
            },
          }}
        />
      }
    />
  );
};
ReadOnlyInput.propTypes = {
  screen: PropTypes.string,
  modal: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  lookup: PropTypes.array,
  consignment: PropTypes.bool,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default ReadOnlyInput;
